// extracted by mini-css-extract-plugin
export default {"item":"nav-item_item__JQ7eL"};